import * as React from "react";

import "./zoom.scss";

import {cs}      from "@Common/react/chain-services";
import {Slider1} from "@Common/ui-components/image-editor/common/opacity-selector/slider-1/slider-1";

import {scales} from "./scales";

export const Zoom = ({control, useSlider}) => cs(
    () => (
        <div className="zoom zoom-1w5">
            {/*{console.log(scales.indexOf(control.current) / (scales.length-1))}*/}
            {!useSlider ? <>
                <button
                    xd-qa-type="button"
                    xd-qa-name="zoomIn"
                    onClick={control.zoomIn}
                >
                    +
                </button>
                <button
                    xd-qa-type="button"
                    xd-qa-name="zoomOut"
                    onClick={control.zoomOut}
                >
                    -
                </button>
            </> : (
                Slider1({
                    state: {
                        value: scales.indexOf(control.current) / (scales.length-1),
                        // value: .3,
                        onChange: (v) => control.onChange(scales[Math.floor(v * (scales.length-1))]),
                    },
                    next: (slider) => slider.render({
                        direction: "vertical",
                        height: 210,
                    }),
                })
            )}

        </div>
    ),
);
